import { validateDateBetween } from './dateBetween';

export const baseDateValidation = (context: DynamicForm.Context, field: DynamicForm.Data, params: any) => {
	return validateDateBetween(context, field, params);
};
